<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="col-sm-12 login-right-contents">
          <div class="login-inner">
            <h1 class="text-nowrap">JET 試験管理 アカウント登録</h1>
            <form v-form>
              <div class="form-group">
                <label for="loginId">教室名</label>
                <div class="form-control-static text-left">{{siteName}}</div>
                <label for="loginId">メールアドレス</label>
                <div class="form-control-static text-left mb-2">{{email}}</div>
                <input type="hidden" name="loginId" :value="email">
                <label for="name">お名前</label>
                <input-text v-model="form.name" :error="$error('name')"
                  inputClass="mb-2" />
                <label for="passowrd">パスワード（英字・数字をそれぞれ１文字以上含め、8文字以上入力してください）</label>
                <input-password v-model="form.password" :error="$error('password')"
                  inputClass="mb-2" />
                <label for="passowrd">パスワード（確認のためもう一度ご入力ください）</label>
                <input-password v-model="form.confirmationPassword" :error="$error('confirmationPassword')"
                  inputClass="mb-2" />
              </div>
              <div class="text-center"><span @click="register" class="btn btn-primary font-weight-bold">アカウント登録する</span></div>
            </form>
          </div>
        </div>
        <div class="col-sm-12">
          <footer class="footer">
            <p>© 2022 JET Committee.</p>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Service} from './_resource';

export default {
  data () {
    return {
      siteName: '',
      email: '',
      form: {
        name: '',
        password: '',
        confirmationPassword: '',
      },
      error: null,
    }
  },
  created () {
    Service.getSignUpInfo()
        .then(data => {
          if (data == null) {
            this.$move('start');
            return;
          }
          if (data.email == null) {
            this.$move('email');
            return;
          }
          if (!data.confirmed) {
            this.$move('confirm');
            return;
          }
          if (data.used) {
            this.$move('completed');
            return;
          }
          this.siteName = data.siteName;
          this.email = data.email;
        })
        .catch(() => {
          this.$move('start');
        })
  },
  mounted() {
    document.body.classList.add('login')
  },
  methods: {
    register () {
      Service.register(this.form)
        .then(() => {
          this.$move('completed');
        })
        .catch(error => {
          this.error = error;
        });
    }
  }
};
</script>
